import { DirectiveOptions } from 'vue';

let emitEvent = function(e: any): void {};

const directive: DirectiveOptions = {
    bind(el, binding, node) {
        emitEvent = function(e: any): void {
            node.context?.$emit("clickOutside", e);
        }

        el.addEventListener('click', (event) => event.stopPropagation());
        document.addEventListener('click', (event) => emitEvent(event));
    },
    unbind(el, binding, node) {
        el.removeEventListener('click', (event) => event.stopPropagation());
        document.removeEventListener('click', (event) => emitEvent(event));
    }
};

export default directive;